





































































import { Component, Vue, Mixins, Watch } from "vue-property-decorator";
import loading from "@/mixins/loading";
import { orderReturnDetail} from "@/api/order";

@Component({
  components: {},
})
export default class OrderDetail extends Mixins(loading) {
  afterDetail: any = {
    omsOrderReturnHistories: [],
    omsOrderItem:{}
  };
  subOrderId: any = "";

  mounted() {
    let route: any = this.$route;
    let { orderId } = route.query;
    if (!orderId) {
      this.$message.error("订单号不能为空");
      return;
    }
    this.subOrderId = orderId;
    this.showLoading();
    this.getData();
  }

  getData() {
    orderReturnDetail({
      subOrderId: this.subOrderId,
    }).then((res: any) => {
      this.afterDetail = res.data;
      this.hideLoading();
    });
  }

    // 查看详情
  viewDetail(item: any) {
    let orderId = this.afterDetail.id;
    this.$router.push({
      path: "/orderDetail",
      query: { orderId: orderId },
    });
  }

    // 表头样式
  headerCellStyle() {
    return {
      background: '#eef1f6', color: '#606266', textAlign: 'center'
    }
  }
}
